






















































/** Копируем запасным способом: navigator.clipboard недоступен на части установок по http */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { copyTextToClipboard } from '../core/download';

const COPIED_FEEDBACK_MS = 2000;

interface MmStateSpec {
	icon: string;
	tone: string;
	titleKey: string;
	/** null — типового объяснения нет: текст собирается динамически или не нужен вовсе */
	hintKey: string | null;
}

const KEY_PREFIX = 'priceMonitoring.mobileMonitoring.states.';

const STATE_SPECS: { [key: string]: MmStateSpec } = {
	empty: {
		icon: 'inbox',
		tone: 'neutral',
		titleKey: KEY_PREFIX + 'empty',
		hintKey: null,
	},
	error: {
		icon: 'exclamation-circle',
		tone: 'danger',
		titleKey: KEY_PREFIX + 'error',
		hintKey: null,
	},
	networkNotSelected: {
		icon: 'shop',
		tone: 'info',
		titleKey: KEY_PREFIX + 'networkNotSelected',
		hintKey: KEY_PREFIX + 'networkNotSelectedHint',
	},
	networkOutOfSync: {
		icon: 'swap',
		tone: 'info',
		titleKey: KEY_PREFIX + 'networkOutOfSync',
		hintKey: KEY_PREFIX + 'networkOutOfSyncHint',
	},
	forbidden: {
		icon: 'lock',
		tone: 'info',
		titleKey: KEY_PREFIX + 'forbidden',
		hintKey: KEY_PREFIX + 'forbiddenHint',
	},
	unavailable: {
		icon: 'disconnect',
		tone: 'warning',
		titleKey: KEY_PREFIX + 'unavailable',
		hintKey: KEY_PREFIX + 'unavailableHint',
	},
	spSessionExpired: {
		icon: 'clock-circle',
		tone: 'warning',
		titleKey: KEY_PREFIX + 'spSessionExpired',
		hintKey: KEY_PREFIX + 'spSessionExpiredHint',
	},
	misconfigured: {
		icon: 'setting',
		tone: 'warning',
		titleKey: KEY_PREFIX + 'misconfigured',
		hintKey: KEY_PREFIX + 'misconfiguredHint',
	},
};

@Component
export default class MmStates extends Vue {
	@Prop({ required: true }) readonly state!: string;

	@Prop({ default: '' }) readonly errorText!: string;

	@Prop({ default: '' }) readonly diagnostics!: string;

	@Prop({ default: false }) readonly retryable!: boolean;

	@Prop({ default: '' }) readonly titleOverride!: string;

	@Prop({ default: '' }) readonly textOverride!: string;

	isDiagnosticsOpen: boolean = false;
	isCopied: boolean = false;

	private copiedTimer: number | null = null;

	get resolvedState(): string {
		if (this.state === 'loading') {
			return 'loading';
		}

		return STATE_SPECS[this.state] ? this.state : 'error';
	}

	get spec(): MmStateSpec {
		const found = STATE_SPECS[this.resolvedState];

		return found ? found : STATE_SPECS.error;
	}

	get title(): string {
		if (this.titleOverride !== '') {
			return this.titleOverride;
		}

		return this.$t(this.spec.titleKey) as string;
	}

	get hint(): string {
		if (this.textOverride !== '') {
			return this.textOverride;
		}

		if (this.resolvedState === 'error') {
			const fromService = this.errorText ? String(this.errorText).trim() : '';

			return fromService !== '' ? fromService : (this.$t(KEY_PREFIX + 'unavailableHint') as string);
		}

		return this.spec.hintKey === null ? '' : (this.$t(this.spec.hintKey) as string);
	}

	get serviceNote(): string {
		if (this.resolvedState !== 'unavailable') {
			return '';
		}

		return this.errorText ? String(this.errorText).trim() : '';
	}

	get showRetry(): boolean {
		return this.retryable === true && this.resolvedState !== 'loading';
	}

	get hasDiagnostics(): boolean {
		return this.resolvedState !== 'loading' && this.diagnostics !== '' && this.diagnostics !== null;
	}

	get loadingText(): string {
		return this.$t(KEY_PREFIX + 'loading') as string;
	}

	get retryText(): string {
		return this.$t(KEY_PREFIX + 'retry') as string;
	}

	get diagnosticsText(): string {
		return this.$t(KEY_PREFIX + 'diagnostics') as string;
	}

	get copyButtonText(): string {
		return this.$t(KEY_PREFIX + (this.isCopied ? 'copied' : 'copy')) as string;
	}

	mounted(): void {
		this.warnAboutUnknownState();
	}

	@Watch('state')
	onStateChanged(): void {
		this.isDiagnosticsOpen = false;
		this.resetCopiedFeedback();
		this.warnAboutUnknownState();
	}

	@Watch('diagnostics')
	onDiagnosticsChanged(): void {
		this.resetCopiedFeedback();
	}

	toggleDiagnostics(): void {
		this.isDiagnosticsOpen = !this.isDiagnosticsOpen;
	}

	handleCopyDiagnostics(): void {
		const ok = copyTextToClipboard(this.diagnostics);

		if (!ok) {
			this.isDiagnosticsOpen = true;

			return;
		}

		this.isCopied = true;
		this.resetCopiedTimer();
		this.copiedTimer = window.setTimeout(() => {
			this.isCopied = false;
			this.copiedTimer = null;
		}, COPIED_FEEDBACK_MS);
	}

	handleRetry(): void {
		this.$emit('retry');
	}

	beforeDestroy(): void {
		this.resetCopiedTimer();
	}

	private resetCopiedFeedback(): void {
		this.isCopied = false;
		this.resetCopiedTimer();
	}

	private resetCopiedTimer(): void {
		if (this.copiedTimer !== null) {
			window.clearTimeout(this.copiedTimer);
			this.copiedTimer = null;
		}
	}

	private warnAboutUnknownState(): void {
		if (process.env.NODE_ENV === 'production') {
			return;
		}

		if (this.state === 'loading' || STATE_SPECS[this.state]) {
			return;
		}

		// tslint:disable-next-line:no-console
		console.warn(
			'[MmStates] неизвестное состояние «' + String(this.state) + '»: показан экран ошибки. '
			+ 'Допустимые значения: loading, ' + Object.keys(STATE_SPECS).join(', ') + '.',
		);
	}
}
